<div class="amendments-toolbar">
  <app-button-establish-amendment [contract]="contract()"></app-button-establish-amendment>
</div>

@if (amendments().length) {
  <table class="amendments">
    <thead>
      <tr>
        <th>N°</th>
        <th>Motifs</th>
        <th>Effet au</th>
        <th>Circuit</th>
        <th>Pièces</th>
        <th>Édité</th>
        <th class="actions">Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (amendment of amendments(); track amendment.id) {
        <tr [class.abandoned]="amendment.status === 'CANCELED'">
          <td>{{ amendment.number ?? '—' }}</td>
          <td>{{ reasonsOf(amendment) }}</td>
          <td>
            {{ amendment.effectiveDate | date: 'dd/MM/yyyy' }}
            @if (amendment.endDate) {
              <span class="temporary">au {{ amendment.endDate | date: 'dd/MM/yyyy' }}</span>
            }
          </td>
          <td>
            @if (amendment.status === 'CANCELED') {
              Abandonné
            } @else {
              <app-contract-status [small]="true" [status]="amendment.status"></app-contract-status>
            }
          </td>
          <td>
            @for (document of amendment.documents; track document.id) {
              <button mat-button class="document" (click)="openDocument(document)">
                <mat-icon>picture_as_pdf</mat-icon>
                {{ document.tag | documentTagLabel }}
              </button>
            }
          </td>
          <td>
            @if (amendment.adpEditedAt || amendment.adpEditedBy) {
              <mat-icon
                class="edited"
                [matTooltip]="editedLabel(amendment)"
                [attr.aria-label]="editedLabel(amendment)"
                >check</mat-icon
              >
            }
          </td>
          <td class="actions">
            <button
              mat-icon-button
              [attr.aria-label]="'Voir l\'avenant ' + (amendment.number ?? '')"
              matTooltip="Voir l'avenant"
              (click)="open(amendment)"
            >
              <mat-icon class="info">visibility</mat-icon>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
} @else {
  <p class="empty">Aucun avenant sur ce contrat.</p>
}
<p class="hint">Le numéro d'un avenant s'attribue à l'acceptation du DRH.</p>
